import { MeetingsList } from "./MeetingsList";
import { MeetingShow } from "./MeetingShow";
import { MeetingCreate } from "./MeetingCreate";
import { MeetingEdit } from "./MeetingEdit";

export default {
  list: MeetingsList,
  show: MeetingShow,
  create: MeetingCreate,
  edit: MeetingEdit,
  recordRepresentation: (record: any) =>
    record?.title ||
    record?.company_name ||
    `Junta #${record?.id ?? "?"}`,
};

export { MeetingsList, MeetingShow, MeetingCreate, MeetingEdit };
